import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SystemService } from 'src/app/core/system.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]    
  })


  constructor(
    private router: Router,
    private authService: AuthService,
    private systemService: SystemService,
    private fb: FormBuilder) { }

  ngOnInit() { 
    
    if(this.authService.isLoggedIn) {
      // redirect to dashboard
      this.router.navigate(['']);
    }

  }

  login() {
    const { username, password } = this.loginForm.value;

    this.authService.login(username, password)
      .subscribe(value => {
        // if success
        if(value.userid > 0) {
          this.router.navigate(['']);
        }
        else {
          // show msg
          alert('user/pass wrong')
        }

      })

  }

}
